import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import ActivateRobotlistPSN from "../../components/robot/ActivateRobotlistPSN";

const { Content } = Layout;

function ActivateRobotPSN({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <ActivateRobotlistPSN />
            </Content>
         </Layout>
      </Layout>
   );
}

export default ActivateRobotPSN;